<template>
  <div>
    <p class="mentionLegal">
      <!-- Réforme -->
      <v-alert text v-if="param != null && param.couleurInfoBulle == 'B'" color="secondary" type="info">
        <span v-html="param.texte"></span>
      </v-alert>
      <v-alert v-if="param != null && param.couleurInfoBulle == 'R'" color="red lighten-2" dark type="error">
        <span v-html="param.texte"></span>
      </v-alert>
      <v-alert text v-if="param != null && param.couleurInfoBulle == 'O'" color="orange" type="error">
        <span v-html="param.texte"></span>
      </v-alert>
    </p>
  </div>
</template>
<script>
import { api } from "../plugins/api"

export default {
  data() {
    return {
      param: {},
    }
  },
  async mounted() {
    this.param = await this.getParam("poc-info-bulle")
  },
  methods: {
    async getParam(code) {
      const result = await api.get(`paramInfoBulle?code=` + code)
      console.log(result.data)
      return result.data
    },
  },
}
</script>
